module.exports = __webpack_public_path__ + "static/media/03.ea6754f8.mp3";